import React from 'react'
import Navbar from '../Components/Navbar'
import Top from '../Components/Top'
import Sponsors from '../Components/Sponsors'
import Preview from '../Components/Preview';
import ThemeSong from '../Components/ThemeSong';
import Title from '../Components/Title';
import What from '../Components/What';
import Button from '../Components/Button';
import Footer from '../Components/Footer'
import { useEffect } from 'react';

function Index() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);    
  return (
    <div className='block flex items-center justify-center text-center'>
        {/* <Navbar />
        <Top />
        <Title/>
        <What/>
        <Button/>
        {/* <Preview />}
        <ThemeSong />
        <Sponsors />
        <Footer /> */}
        <span className='text-3xl font-bold'>Web In Progress</span>
    </div>
  )
}


export default Index